export default (route) => {
  const organizationId = route.split("/")[1];
  return organizationId;
};
